/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import "../../../assets/styles/custom-style.css";
import { useAuth } from "../../../auth";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { deleteIngredient } from "../core/_requests";

const DeleteIngredient = () => {
  const { id } = useParams(); // Extract Ingredient ID from URL
  const navigate = useNavigate();
  const { currentUser } = useAuth(); // Current user data (unused but can be used for permission check)

  const deleteItem = async () => {
        try {
      const res: { status: boolean; message: string } = await deleteIngredient(id);

      if (res?.status) {
        toast.success(res.message);
        navigate("/ingredients"); // Navigate after a successful response
      } else {
        toast.error(res.message || "Failed to delete Ingredient", { autoClose: 5000 });
      }
    } catch (error) {
      console.error("Error deleting Ingredient:", error);
      toast.error("Something went wrong while deleting the Ingredient.");
    }
  };

  const clickCancel = () => {
    navigate("/ingredients"); // Navigate back to Ingredient list
  };

  return (
    <section className="container-fluid">
      <div className="row">
        <div className="overlay"></div>
        <div className="drawer small">
          <div className="alert-wrap">
            {/* Adjust the asset path for production */}
            <img
              className="ico mb-4"
              src="//assets/images/alert-warning-ico.svg"
              alt="warning"
            />
            <h1 className="mb-3">Are you sure?</h1>
            <p className="mid-gray mb-4 text-center">
              <small>
                Do you want to delete this Ingredient? You cannot retrieve <br />
                this Ingredient once deleted.
              </small>
            </p>
            <button
              className="btn btn-danger rounded-5 px-5 mt-2 mb-2"
              onClick={deleteItem}
            >
              Yes, Delete
            </button>
            <button
              className="btn btn-cancel rounded-5"
              onClick={clickCancel}
            >
              No, I don't want to delete
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DeleteIngredient;
